<template>
  <v-container id="meeting-list">
    <v-row>
      <v-col>
        <app-city-combobox :filter="filter"></app-city-combobox>
      </v-col>

      <v-col>
        <app-consultant-combobox
          :filter="filter"
          v-if="isAdmin"
        ></app-consultant-combobox>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataInicialString"
          v-mask="'##/##/####'"
          label="Data Inicial"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="getMeetings()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template slot="no-data">
            <span> Nenhuma {{ isAT ? "Atividade" : "Tarefa" }} retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { AppConsultantCombobox } from "@/modules/user";
import { AppCityCombobox } from "@/modules/city";
import { meetingAPI } from "../API/MeetingAPI";

export default {
  components: {
    AppCityCombobox,
    AppConsultantCombobox,
  },
  computed: {
    ...mapGetters(["isAdmin", "user", "isAT", "isGov"]),
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nomeEncontro" },
        { text: "Município", value: "nomeMunicipio" },
        { text: "Início", value: "inicio" },
        { text: "Fim", value: "fim" },
        { text: "Distância", value: "distancia" },
      ],
      payload: [],
      filter: {},
    };
  },
  mounted() {
    if (this.isGov) {
      this.headers = [
        { text: "Nome", value: "nomeEncontro" },
        { text: "Projeto", value: "nomeMunicipio" },
        { text: "Início", value: "inicio" },
        { text: "Fim", value: "fim" },
        { text: "Distância", value: "distancia" },
      ];
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    getMeetings() {
      this.setLoading(true);
      meetingAPI
        .getMeetingByFilter(this.filter)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter rota do ${this.isAT ? "ATS" : "Consultor"}:`
          );
        });
    },
  },
};
</script>
